module.exports = __webpack_public_path__ + "img/nbc.34107983.png";